module.exports = __webpack_public_path__ + "img/dentalfit_14_a.23903231.jpg";